import React, {
  useCallback, useContext, useEffect, useLayoutEffect, useRef,
} from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { WinManagerContext } from '../../providers';

function WindowsManager() {
  const ref = useRef();
  const location = useLocation();
  const {
    linkComponents, currentURL, containerRefs, registerEventListener,
  } = useContext(WinManagerContext);
  const scrolls = useRef({});
  const onCloseWindow = useCallback((closeUrl) => {
    scrolls.current = Object.keys(scrolls.current)
      .filter((key) => key !== closeUrl)
      .reduce((R, k) => ({ ...R, [k]: scrolls.current[k] }), {});
  }, []);
  useEffect(
    () => registerEventListener('', 'onClose', onCloseWindow),
    [onCloseWindow, registerEventListener],
  );

  useLayoutEffect(
    () => {
      const rc = ref.current;
      const sc = scrolls.current;
      if (rc && sc[location.pathname]) {
        setTimeout(
          () => rc.scrollTo(sc[location.pathname].x, sc[location.pathname].y),
          10,
        );
      }
      return () => {
        if (rc) {
          sc[location.pathname] = {
            x: rc.scrollLeft,
            y: rc.scrollTop,
          };
        }
      };
    },
    [location.pathname],
  );
  return (
    <div
      className="windows-manager scrollbar d-flex flex-fill"
      id="docBody"
      ref={ref}
    >
      {
        linkComponents.map((el) => {
          const Comp = el.component;
          const { leftToolBar } = el.props;
          return (
            <div
              key={`windowed-component-of-${el.url}`}
              className={classNames('py-2 h-100', { 'd-none': el.url !== currentURL, 'w-100': !leftToolBar })}
              ref={containerRefs(el.url)}
            >
              <Comp {...el.props} />
            </div>
          );
        })
      }
    </div>
  );
}

export default WindowsManager;
